






























































import Component, {mixins} from 'vue-class-component'
import {State} from 'vuex-class';
import {Route} from 'vue-router';
import {Watch} from 'vue-property-decorator';
import ReleaseLog, {LogLevel} from '@/modules/app-router/model/ReleaseLog';
import {DateMixin} from '@/modules/core/date';
import LogMixin from '@/modules/app-router/components/AppRelease/LogMixin';

/**
 * Detalle de un registro de eventos
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class LogDetail extends mixins(DateMixin, LogMixin) {
    /**
     * Registro actualmente seleccionado por el usuario
     */
    @State(state => state.appRouter.currentLog)
    public log: ReleaseLog

    @Watch('$route', {immediate: true})
    public async watchRouter (route: Route) {
        await this.$store.dispatch('appRouter/loadLog', route.params.id)
    }
}
